import { useContext } from 'react';

import SwiperContext, { SwiperContextValues } from './context';

const useSwiperContext = (): SwiperContextValues => useContext(SwiperContext);

export default useSwiperContext;
